export default "__VITE_ASSET__hCDT8aHN__"